import { render } from "./OrganizationCLOCommonPage.vue?vue&type=template&id=1c6b27c8&scoped=true"
import script from "./OrganizationCLOCommonPage.vue?vue&type=script&lang=js"
export * from "./OrganizationCLOCommonPage.vue?vue&type=script&lang=js"

import "./OrganizationCLOCommonPage.vue?vue&type=style&index=0&id=1c6b27c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6b27c8"]])

export default __exports__